import React from "react"
import {Button} from "semantic-ui-react"
import PropTypes from "prop-types"
import { trackRemoveFromCart } from "components/tracking/Tracking";

export default function ProductRowCartAction  ( { cart, product } )  {
	return (
		<Button className="productRowCartAction"
			onClick={() => {
				console.log("remove product", product, cart)
				cart.remove( product )
				trackRemoveFromCart(product.map_id, product.title)
			}}
			style={{border: "none", background: "none"}}
			icon="trash alternate"
			size="big"
		/>
	)
}

ProductRowCartAction.propTypes = {
	cart:    PropTypes.object,
	product: PropTypes.object,
}





// WEBPACK FOOTER //
// ./src/theme/trendimport.test/components/Product/ProductRowCartAction.js